import { useSelector } from 'react-redux';

const useAuthToken = () => {
  const user = useSelector(state => state.user.user);

  return user?.user?.token;
};

export default useAuthToken;
